import { type CommonWildberriesProblem as LinkCommonWildberriesProblem } from '../links/CommonWildberriesProblem';
import { type YandexMarketImportRequest as SchemaYandexMarketImportRequest } from '../schemas/YandexMarketImportRequest';
import { type YandexMarketImportResponse as SchemaYandexMarketImportResponse } from '../schemas/YandexMarketImportResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const ImportYandexMarketSetupContentType = 'application/json' as const;
export type ImportYandexMarketSetupRequest = SchemaYandexMarketImportRequest;
export type ImportYandexMarketSetupResponses = LinkCommonWildberriesProblem & {
    /**
     * @description Yandex Market settings set successfully
     */
    '200': {
        'application/json': SchemaYandexMarketImportResponse;
    };
};
export type ImportYandexMarketSetupResponseSuccess = ImportYandexMarketSetupResponses['200']['application/json'];
export type ImportYandexMarketSetupSearchParams = undefined;
export type ImportYandexMarketSetupPathParameters = undefined;
export const ImportYandexMarketSetupUrl = '/integrations/yamarket/setup' as const;
export const ImportYandexMarketSetupMethod = 'POST' as const;
export const getImportYandexMarketSetupUrl = (_params?: ImportYandexMarketSetupPathParameters) =>
    ImportYandexMarketSetupUrl;
